import api from "api/api";

export const createRegion = async (data) =>
  await api.post("/settings/region", data);

export const deleteRegionById = async (id) =>
  await api.delete(`/settings/region/${id}`);

export const getRegionById = async (id) =>
  await api.get(`/settings/region/${id}`);

export const getRegionList = async () => await api.get("/settings/region");

export const updateRegionById = async (id, data) =>
  await api.put(`/settings/region/${id}`, data);
